import React, { useCallback } from "react";
import { Col, Row } from "antd";

import MarketReferenceHeader from "../marketReference/MarketReferenceHeader";
import MarketSeriesPanel from "../marketReference/MarketSeriesPanel";
import DailyQuoteHistoryPanel from "../marketReference/DailyQuoteHistoryPanel";
import useMarketReferencePriceData from "../../hooks/useMarketReferencePriceData";

const MarketReferenceWorkbenchPanel = () => {
    const {
        sourceOptions,
        sourcesLoading,
        seriesFilters,
        setSeriesFilters,
        series,
        seriesLoading,
        seriesPagination,
        searchSeries,
        resetSeriesFilters,
        handleSeriesTableChange,
        selectedSeriesId,
        selectSeries,
        selectedSeries,
        selectedSeriesLoading,
        quoteFilters,
        setQuoteFilters,
        resetQuoteFilters,
        quotes,
        quotesLoading,
        quotePagination,
        handleQuoteTableChange,
    } = useMarketReferencePriceData();

    const handleSeriesFilterChange = useCallback((updater) => {
        setSeriesFilters((current) => updater(current));
    }, [setSeriesFilters]);

    return (
        <div>
            <MarketReferenceHeader />

            <Row gutter={[16, 16]}>
                <Col xs={24} xl={10}>
                    <MarketSeriesPanel
                        filters={seriesFilters}
                        onFilterChange={handleSeriesFilterChange}
                        onSearch={searchSeries}
                        onReset={resetSeriesFilters}
                        sourceOptions={sourceOptions}
                        sourcesLoading={sourcesLoading}
                        series={series}
                        seriesLoading={seriesLoading}
                        pagination={seriesPagination}
                        selectedSeriesId={selectedSeriesId}
                        onSelectSeries={selectSeries}
                        onTableChange={handleSeriesTableChange}
                    />
                </Col>

                <Col xs={24} xl={14}>
                    <DailyQuoteHistoryPanel
                        selectedSeries={selectedSeries}
                        selectedSeriesLoading={selectedSeriesLoading}
                        quoteFilters={quoteFilters}
                        setQuoteFilters={setQuoteFilters}
                        resetQuoteFilters={resetQuoteFilters}
                        quotes={quotes}
                        quotesLoading={quotesLoading}
                        quotePagination={quotePagination}
                        onQuoteTableChange={handleQuoteTableChange}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default MarketReferenceWorkbenchPanel;
